import type { VoicePromptType } from "../../Types/VoiceAssistant/VoiceAssistantTypes";
import { isAiChatUiVoiceCommand } from "../../utilis/methods/voiceAssistant/aiChatVoiceCommands";
import { isEmrRoute } from "../../utilis/methods/voiceAssistant/emrRoute";
import { isEmrLandingRoute } from "../../utilis/methods/voiceAssistant/emrLandingRoute";
import { isPatientSelectionPrompt } from "../../utilis/methods/voiceAssistant/patientSelectionVoice";

const MENU_NAV_PHRASES = ["navigate to", "go to", "navigate"] as const;
const REPORT_PHRASES = ["report", "pdf", "print report", "generate report"] as const;

export function inferVoicePromptType(
  prompt: string,
  pathname: string,
): VoicePromptType {
  const lower = prompt.toLowerCase();

  if (isAiChatUiVoiceCommand(prompt)) {
    return null;
  }

  if (isEmrRoute(pathname)) {
    if (REPORT_PHRASES.some((phrase) => lower.includes(phrase))) {
      return "pdf";
    }
    if (/\bchat\b/i.test(lower)) {
      return "chat";
    }
    return "field-summary";
  }

  if (isEmrLandingRoute(pathname)) {
    if (isPatientSelectionPrompt(prompt)) {
      return "patient-selection";
    }
    return null;
  }

  if (MENU_NAV_PHRASES.some((phrase) => lower.includes(phrase))) {
    return "menu";
  }

  if (lower.startsWith("open ") && !isAiChatUiVoiceCommand(prompt)) {
    return "menu";
  }

  return null;
}
